import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';

/**
 * Renders a text grid cell.
 */
@Component({
  selector: 'grid-cell-renderer',
  templateUrl: './grid-cell-renderer.component.html',
  styleUrl: './grid-cell-renderer.component.css'
})
export class GridCellRendererComponent implements ICellRendererAngularComp {
	trustedValue: SafeHtml = "";
	value: string = "";

	constructor(
		private sanitizer: DomSanitizer
	) {}
	
	agInit(params: ICellRendererParams): void {
	    this.refresh(params);
	}
	
	refresh(params: ICellRendererParams): boolean {
		this.value = params.value || '';
		this.trustedValue = this.sanitizer.bypassSecurityTrustHtml(this.value);
	    return true;
	}
}
